export default __webpack_public_path__ + "static/michalBonczyk-2269b9fa56e1e204ba7298eae5a04248.png";